<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
    [modalHelpIndex]="modalHelpIndex" [primaryButtonLabel]="primaryButtonLabel"
    [primaryButtonCustomClass]="primaryButtonLabel === 'Search'? 'primary-button-search' : ''"
    (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
    [resizeHorizontal]="true" [resizeHorizontalMin]="500" [resizeVertical]="true" [resizeVerticalMin]="500"
    [maximizable]="maximizable">

    <res-target-picker-tree [targetPickerTreeType]="targetPickerTreeType" [updateStatusType]="updateStatusType"
        [doubleClickAction]="doubleClickAction.bind(this)" [preselectNodePredicate]="preselectNodePredicate"
        [automationId]="modalAutomationId + '-tree'">
    </res-target-picker-tree>
    <div class="data-set-filter" *ngIf="dataSetFilterVisible">
        <label>Filter by Data Set(s):</label>
        <input type="text" [ngModel]="dataSetFilterQuery" readonly="true"
            [attr.data-automation-id]="modalAutomationId + '-data-set-filter-input'">
        <button class="filter-clear" *ngIf="dataSetFilterQuery.trim()" (click)="clearDataSetFilter()"
            [attr.data-automation-id]="modalAutomationId + '-data-set-filter-input-clear-button'">
            <i class="fa fa-times"></i>
        </button>
        <button type="button" [attr.data-automation-id]="modalAutomationId + '-data-set-filter-select-button'"
            class="secondary-button" (click)="selectDataSets()">
            Select ...
        </button>
    </div>
    <div class="threshold" *ngIf="threshold !== null && !hideThreshold">
        <label>Threshold:</label>
        <input type="text" [(ngModel)]="threshold" [attr.data-automation-id]="modalAutomationId + '-threshold-input'"
            max="99" maxlength="2" min="0"
            onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57">
        <span class="hint">(0 - 99)</span>
    </div>
    <div class="htmlSizes" *ngIf="htmlSizes === true || htmlSizes === false">
        <res-custom-checkbox [automationId]="modalAutomationId+ '-tree-provide-html-mhtml-size'"
            content="Provide HTML/MHTML Sizes" [(ngModel)]="htmlSizes"></res-custom-checkbox>
        <div class="fa fa-hourglass-half" [attr.data-automation-id]="modalAutomationId + '-tree-hour-glass-icon'"
            title="Enabling this option will convert documents when the report is run. The report may take considerably longer to generate.">
        </div>
    </div>
</res-base-modal>